import { toString, Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { tuple_type, union_type, option_type, class_type, bool_type, int32_type, record_type, array_type, uint8_type, string_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { equals } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { singleton, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";

export class S3UploadFile extends Record {
    constructor(FileName, MimeType, Payload) {
        super();
        this.FileName = FileName;
        this.MimeType = MimeType;
        this.Payload = Payload;
    }
}

export function S3UploadFile_$reflection() {
    return record_type("Shared.SharedModels.S3UploadFile", [], S3UploadFile, () => [["FileName", string_type], ["MimeType", string_type], ["Payload", array_type(uint8_type)]]);
}

export class Task extends Record {
    constructor(Id, Name, Description, VerificationRequired) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.VerificationRequired = VerificationRequired;
    }
}

export function Task_$reflection() {
    return record_type("Shared.SharedModels.Task", [], Task, () => [["Id", int32_type], ["Name", string_type], ["Description", string_type], ["VerificationRequired", bool_type]]);
}

export class CompletedTask extends Record {
    constructor(Task, Completed, EventId) {
        super();
        this.Task = Task;
        this.Completed = Completed;
        this.EventId = EventId;
    }
}

export function CompletedTask_$reflection() {
    return record_type("Shared.SharedModels.CompletedTask", [], CompletedTask, () => [["Task", Task_$reflection()], ["Completed", class_type("System.DateTime")], ["EventId", option_type(int32_type)]]);
}

export class NewTask extends Record {
    constructor(Name, Description, VerificationRequired) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.VerificationRequired = VerificationRequired;
    }
}

export function NewTask_$reflection() {
    return record_type("Shared.SharedModels.NewTask", [], NewTask, () => [["Name", string_type], ["Description", string_type], ["VerificationRequired", bool_type]]);
}

export class UpdatedTask extends Record {
    constructor(Name, Description, VerificationRequired) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.VerificationRequired = VerificationRequired;
    }
}

export function UpdatedTask_$reflection() {
    return record_type("Shared.SharedModels.UpdatedTask", [], UpdatedTask, () => [["Name", string_type], ["Description", string_type], ["VerificationRequired", bool_type]]);
}

export class NewCourse extends Record {
    constructor(Name, Summary, Description, Tasks, Image) {
        super();
        this.Name = Name;
        this.Summary = Summary;
        this.Description = Description;
        this.Tasks = Tasks;
        this.Image = Image;
    }
}

export function NewCourse_$reflection() {
    return record_type("Shared.SharedModels.NewCourse", [], NewCourse, () => [["Name", string_type], ["Summary", string_type], ["Description", string_type], ["Tasks", array_type(NewTask_$reflection())], ["Image", option_type(S3UploadFile_$reflection())]]);
}

export class Course extends Record {
    constructor(Id, Name, Summary, Description, ImageUrl, ThumbnailUrl, Inserted, Tasks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Summary = Summary;
        this.Description = Description;
        this.ImageUrl = ImageUrl;
        this.ThumbnailUrl = ThumbnailUrl;
        this.Inserted = Inserted;
        this.Tasks = Tasks;
    }
}

export function Course_$reflection() {
    return record_type("Shared.SharedModels.Course", [], Course, () => [["Id", int32_type], ["Name", string_type], ["Summary", string_type], ["Description", option_type(string_type)], ["ImageUrl", option_type(string_type)], ["ThumbnailUrl", option_type(string_type)], ["Inserted", class_type("System.DateTime")], ["Tasks", array_type(Task_$reflection())]]);
}

export class UpdateCourse extends Record {
    constructor(Course, ImagePayLoad) {
        super();
        this.Course = Course;
        this.ImagePayLoad = ImagePayLoad;
    }
}

export function UpdateCourse_$reflection() {
    return record_type("Shared.SharedModels.UpdateCourse", [], UpdateCourse, () => [["Course", Course_$reflection()], ["ImagePayLoad", option_type(S3UploadFile_$reflection())]]);
}

export class TrackLevelCourse extends Record {
    constructor(Id, TrackLevelId, Course, Order, Inserted) {
        super();
        this.Id = (Id | 0);
        this.TrackLevelId = (TrackLevelId | 0);
        this.Course = Course;
        this.Order = (Order | 0);
        this.Inserted = Inserted;
    }
}

export function TrackLevelCourse_$reflection() {
    return record_type("Shared.SharedModels.TrackLevelCourse", [], TrackLevelCourse, () => [["Id", int32_type], ["TrackLevelId", int32_type], ["Course", Course_$reflection()], ["Order", int32_type], ["Inserted", class_type("System.DateTime")]]);
}

export class TrackLevel extends Record {
    constructor(Id, Name, Description, TrackId, Order, Inserted, NotifyMaterial, TrackLevelCourses, Tasks, RequiredTasks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.TrackId = (TrackId | 0);
        this.Order = (Order | 0);
        this.Inserted = Inserted;
        this.NotifyMaterial = NotifyMaterial;
        this.TrackLevelCourses = TrackLevelCourses;
        this.Tasks = Tasks;
        this.RequiredTasks = RequiredTasks;
    }
}

export function TrackLevel_$reflection() {
    return record_type("Shared.SharedModels.TrackLevel", [], TrackLevel, () => [["Id", int32_type], ["Name", string_type], ["Description", string_type], ["TrackId", int32_type], ["Order", int32_type], ["Inserted", class_type("System.DateTime")], ["NotifyMaterial", bool_type], ["TrackLevelCourses", array_type(TrackLevelCourse_$reflection())], ["Tasks", array_type(Task_$reflection())], ["RequiredTasks", array_type(Task_$reflection())]]);
}

export class NewTrack extends Record {
    constructor(Name, Description, ImagePayload) {
        super();
        this.Name = Name;
        this.Description = Description;
        this.ImagePayload = ImagePayload;
    }
}

export function NewTrack_$reflection() {
    return record_type("Shared.SharedModels.NewTrack", [], NewTrack, () => [["Name", string_type], ["Description", string_type], ["ImagePayload", option_type(S3UploadFile_$reflection())]]);
}

export class Track extends Record {
    constructor(Id, Name, Description, Enabled, ImageUrl, ThumbnailUrl, Inserted, TrackLevels, ReactivationTasks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Description = Description;
        this.Enabled = Enabled;
        this.ImageUrl = ImageUrl;
        this.ThumbnailUrl = ThumbnailUrl;
        this.Inserted = Inserted;
        this.TrackLevels = TrackLevels;
        this.ReactivationTasks = ReactivationTasks;
    }
}

export function Track_$reflection() {
    return record_type("Shared.SharedModels.Track", [], Track, () => [["Id", int32_type], ["Name", string_type], ["Description", string_type], ["Enabled", bool_type], ["ImageUrl", option_type(string_type)], ["ThumbnailUrl", option_type(string_type)], ["Inserted", class_type("System.DateTime")], ["TrackLevels", array_type(TrackLevel_$reflection())], ["ReactivationTasks", array_type(Task_$reflection())]]);
}

export class UpdateTrack extends Record {
    constructor(Track, ImagePayLoad) {
        super();
        this.Track = Track;
        this.ImagePayLoad = ImagePayLoad;
    }
}

export function UpdateTrack_$reflection() {
    return record_type("Shared.SharedModels.UpdateTrack", [], UpdateTrack, () => [["Track", Track_$reflection()], ["ImagePayLoad", option_type(S3UploadFile_$reflection())]]);
}

export class TrackInactiveOverview extends Record {
    constructor(Track, BlockedCourses, ReactivationCourses) {
        super();
        this.Track = Track;
        this.BlockedCourses = BlockedCourses;
        this.ReactivationCourses = ReactivationCourses;
    }
}

export function TrackInactiveOverview_$reflection() {
    return record_type("Shared.SharedModels.TrackInactiveOverview", [], TrackInactiveOverview, () => [["Track", Track_$reflection()], ["BlockedCourses", array_type(Course_$reflection())], ["ReactivationCourses", array_type(Course_$reflection())]]);
}

export class EnrolledTrack extends Record {
    constructor(Track, CurrentTrackLevelId, PromotedAt, Inactive) {
        super();
        this.Track = Track;
        this.CurrentTrackLevelId = (CurrentTrackLevelId | 0);
        this.PromotedAt = PromotedAt;
        this.Inactive = Inactive;
    }
}

export function EnrolledTrack_$reflection() {
    return record_type("Shared.SharedModels.EnrolledTrack", [], EnrolledTrack, () => [["Track", Track_$reflection()], ["CurrentTrackLevelId", int32_type], ["PromotedAt", class_type("System.DateTime")], ["Inactive", bool_type]]);
}

export class Region extends Record {
    constructor(Id, Name, Enabled) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function Region_$reflection() {
    return record_type("Shared.SharedModels.Region", [], Region, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type]]);
}

export class NewRegion extends Record {
    constructor(Name, Enabled) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
    }
}

export function NewRegion_$reflection() {
    return record_type("Shared.SharedModels.NewRegion", [], NewRegion, () => [["Name", string_type], ["Enabled", bool_type]]);
}

export class Title extends Record {
    constructor(Id, Name) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
    }
}

export function Title_$reflection() {
    return record_type("Shared.SharedModels.Title", [], Title, () => [["Id", int32_type], ["Name", string_type]]);
}

export class NewTitle extends Record {
    constructor(Name) {
        super();
        this.Name = Name;
    }
}

export function NewTitle_$reflection() {
    return record_type("Shared.SharedModels.NewTitle", [], NewTitle, () => [["Name", string_type]]);
}

export class UpdatedTitle extends Record {
    constructor(Id, Name) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
    }
}

export function UpdatedTitle_$reflection() {
    return record_type("Shared.SharedModels.UpdatedTitle", [], UpdatedTitle, () => [["Id", int32_type], ["Name", string_type]]);
}

export class Workplace extends Record {
    constructor(Id, Name, Enabled, Region, Municipality, Tracks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.Region = Region;
        this.Municipality = Municipality;
        this.Tracks = Tracks;
    }
}

export function Workplace_$reflection() {
    return record_type("Shared.SharedModels.Workplace", [], Workplace, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["Region", Region_$reflection()], ["Municipality", string_type], ["Tracks", array_type(Track_$reflection())]]);
}

export class NewWorkplace extends Record {
    constructor(Name, Enabled, RegionId, Municipality) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.RegionId = (RegionId | 0);
        this.Municipality = Municipality;
    }
}

export function NewWorkplace_$reflection() {
    return record_type("Shared.SharedModels.NewWorkplace", [], NewWorkplace, () => [["Name", string_type], ["Enabled", bool_type], ["RegionId", int32_type], ["Municipality", string_type]]);
}

export class UpdatedWorkplace extends Record {
    constructor(Id, Name, Enabled, RegionId, Municipality, Tracks) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.RegionId = (RegionId | 0);
        this.Municipality = Municipality;
        this.Tracks = Tracks;
    }
}

export function UpdatedWorkplace_$reflection() {
    return record_type("Shared.SharedModels.UpdatedWorkplace", [], UpdatedWorkplace, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["RegionId", int32_type], ["Municipality", string_type], ["Tracks", array_type(Track_$reflection())]]);
}

export class Role extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NormalUser", "Admin", "Teacher", "ExternalTeacher"];
    }
}

export function Role_$reflection() {
    return union_type("Shared.SharedModels.Role", [], Role, () => [[], [], [], []]);
}

export function Role__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 2;
        case 2:
            return 3;
        case 3:
            return 4;
        default:
            return 1;
    }
}

export function Role_FromInt_Z524259A4(x) {
    switch (x) {
        case 1:
            return new Role(0, []);
        case 2:
            return new Role(1, []);
        case 3:
            return new Role(2, []);
        case 4:
            return new Role(3, []);
        default:
            return new Role(0, []);
    }
}

export function Role__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Administrator";
        case 2:
            return "Kursholder";
        case 3:
            return "Ekstern kursholder";
        default:
            return "Kursdeltaker";
    }
}

export function Role__ToLabel(this$) {
    switch (this$.tag) {
        case 1:
            return "Admin";
        case 2:
            return "Lærer";
        case 3:
            return "Ekstern lærer";
        default:
            return "Bruker";
    }
}

/**
 * Returns true when a user whose real role is <paramref name="real"/> is allowed to
 * view the app as <paramref name="requested"/>. Roles can only be matched (no-op) or
 * stepped down the hierarchy: Admin -> {Teacher, ExternalTeacher, NormalUser};
 * Teacher/ExternalTeacher -> NormalUser; NormalUser cannot switch.
 */
export function Role_CanViewAs(real, requested) {
    if (equals(real, requested)) {
        return true;
    }
    else {
        let matchResult;
        switch (real.tag) {
            case 1: {
                switch (requested.tag) {
                    case 2:
                    case 3:
                    case 0: {
                        matchResult = 0;
                        break;
                    }
                    default:
                        matchResult = 2;
                }
                break;
            }
            case 2: {
                if (requested.tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            case 3: {
                if (requested.tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 2;
                }
                break;
            }
            default:
                matchResult = 2;
        }
        switch (matchResult) {
            case 0:
                return true;
            case 1:
                return true;
            default:
                return false;
        }
    }
}

/**
 * The list of roles a user with the given real role can view the app as. Always includes
 * the real role itself first. Returns a single-element list for NormalUser.
 */
export function Role_AllowedViewAs_335EB78D(real) {
    switch (real.tag) {
        case 2:
            return ofArray([new Role(2, []), new Role(0, [])]);
        case 3:
            return ofArray([new Role(3, []), new Role(0, [])]);
        case 0:
            return singleton(new Role(0, []));
        default:
            return ofArray([new Role(1, []), new Role(2, []), new Role(3, []), new Role(0, [])]);
    }
}

export class UserState extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["New", "Enabled", "Deactivated"];
    }
}

export function UserState_$reflection() {
    return union_type("Shared.SharedModels.UserState", [], UserState, () => [[], [], []]);
}

export function UserState__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        default:
            return 0;
    }
}

export function UserState_FromInt_Z524259A4(x) {
    switch (x) {
        case 0:
            return new UserState(0, []);
        case 1:
            return new UserState(1, []);
        case 2:
            return new UserState(2, []);
        default:
            return new UserState(0, []);
    }
}

export function UserState__ToDescription(this$) {
    switch (this$.tag) {
        case 1:
            return "Aktiv";
        case 2:
            return "Deaktivert";
        default:
            return "Venter på godkjenning";
    }
}

export class User extends Record {
    constructor(Id, KeycloakId, FirstName, LastName, State, Role, RealRole, Email, Phone, ImageUrl, ThumbnailUrl, Workplace, Title, HasMaterialAccess, Inserted) {
        super();
        this.Id = (Id | 0);
        this.KeycloakId = KeycloakId;
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.State = State;
        this.Role = Role;
        this.RealRole = RealRole;
        this.Email = Email;
        this.Phone = Phone;
        this.ImageUrl = ImageUrl;
        this.ThumbnailUrl = ThumbnailUrl;
        this.Workplace = Workplace;
        this.Title = Title;
        this.HasMaterialAccess = HasMaterialAccess;
        this.Inserted = Inserted;
    }
}

export function User_$reflection() {
    return record_type("Shared.SharedModels.User", [], User, () => [["Id", int32_type], ["KeycloakId", class_type("System.Guid")], ["FirstName", string_type], ["LastName", string_type], ["State", UserState_$reflection()], ["Role", Role_$reflection()], ["RealRole", Role_$reflection()], ["Email", string_type], ["Phone", string_type], ["ImageUrl", option_type(string_type)], ["ThumbnailUrl", option_type(string_type)], ["Workplace", option_type(Workplace_$reflection())], ["Title", option_type(Title_$reflection())], ["HasMaterialAccess", bool_type], ["Inserted", class_type("System.DateTime")]]);
}

export class UpdatedUser extends Record {
    constructor(FirstName, LastName, Email, Phone, State, Role, WorkplaceId, TitleId) {
        super();
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Email = Email;
        this.Phone = Phone;
        this.State = State;
        this.Role = Role;
        this.WorkplaceId = WorkplaceId;
        this.TitleId = TitleId;
    }
}

export function UpdatedUser_$reflection() {
    return record_type("Shared.SharedModels.UpdatedUser", [], UpdatedUser, () => [["FirstName", string_type], ["LastName", string_type], ["Email", string_type], ["Phone", string_type], ["State", UserState_$reflection()], ["Role", Role_$reflection()], ["WorkplaceId", option_type(int32_type)], ["TitleId", option_type(int32_type)]]);
}

export class Event$ extends Record {
    constructor(Id, Name, Enabled, Summary, Description, Address, MaxAttendees, AttendeeCount, Time, EndTime, SignupDeadline, DateDescription, Finalized, Course, Teacher, SecondaryTeachers, Region) {
        super();
        this.Id = (Id | 0);
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.AttendeeCount = (AttendeeCount | 0);
        this.Time = Time;
        this.EndTime = EndTime;
        this.SignupDeadline = SignupDeadline;
        this.DateDescription = DateDescription;
        this.Finalized = Finalized;
        this.Course = Course;
        this.Teacher = Teacher;
        this.SecondaryTeachers = SecondaryTeachers;
        this.Region = Region;
    }
}

export function Event$_$reflection() {
    return record_type("Shared.SharedModels.Event", [], Event$, () => [["Id", int32_type], ["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["AttendeeCount", int32_type], ["Time", class_type("System.DateTime")], ["EndTime", class_type("System.DateTime")], ["SignupDeadline", class_type("System.DateTime")], ["DateDescription", option_type(string_type)], ["Finalized", bool_type], ["Course", Course_$reflection()], ["Teacher", User_$reflection()], ["SecondaryTeachers", array_type(User_$reflection())], ["Region", Region_$reflection()]]);
}

export class NewEvent extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, EndTime, SignupDeadline, DateDescription, TeacherId, SecondaryTeacherIds, CourseId, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.EndTime = EndTime;
        this.SignupDeadline = SignupDeadline;
        this.DateDescription = DateDescription;
        this.TeacherId = (TeacherId | 0);
        this.SecondaryTeacherIds = SecondaryTeacherIds;
        this.CourseId = (CourseId | 0);
        this.RegionId = (RegionId | 0);
    }
}

export function NewEvent_$reflection() {
    return record_type("Shared.SharedModels.NewEvent", [], NewEvent, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["EndTime", class_type("System.DateTime")], ["SignupDeadline", class_type("System.DateTime")], ["DateDescription", option_type(string_type)], ["TeacherId", int32_type], ["SecondaryTeacherIds", array_type(int32_type)], ["CourseId", int32_type], ["RegionId", int32_type]]);
}

export class UpdatedEvent extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, EndTime, SignupDeadline, DateDescription, TeacherId, SecondaryTeacherIds, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.EndTime = EndTime;
        this.SignupDeadline = SignupDeadline;
        this.DateDescription = DateDescription;
        this.TeacherId = (TeacherId | 0);
        this.SecondaryTeacherIds = SecondaryTeacherIds;
        this.RegionId = (RegionId | 0);
    }
}

export function UpdatedEvent_$reflection() {
    return record_type("Shared.SharedModels.UpdatedEvent", [], UpdatedEvent, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["EndTime", class_type("System.DateTime")], ["SignupDeadline", class_type("System.DateTime")], ["DateDescription", option_type(string_type)], ["TeacherId", int32_type], ["SecondaryTeacherIds", array_type(int32_type)], ["RegionId", int32_type]]);
}

export class EventAttendee extends Record {
    constructor(User, CompletedTasks, TimeSignedUp, Priority) {
        super();
        this.User = User;
        this.CompletedTasks = CompletedTasks;
        this.TimeSignedUp = TimeSignedUp;
        this.Priority = (Priority | 0);
    }
}

export function EventAttendee_$reflection() {
    return record_type("Shared.SharedModels.EventAttendee", [], EventAttendee, () => [["User", User_$reflection()], ["CompletedTasks", array_type(Task_$reflection())], ["TimeSignedUp", class_type("System.DateTime")], ["Priority", int32_type]]);
}

export class AttendanceStatus extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["NotAttending", "AwaitingConfirmation", "Confirmed", "OnWaitlist"];
    }
}

export function AttendanceStatus_$reflection() {
    return union_type("Shared.SharedModels.AttendanceStatus", [], AttendanceStatus, () => [[], [], [], []]);
}

export class CompletionGranter extends Record {
    constructor(Id, FirstName, LastName, Role, ImageUrl, ThumbnailUrl) {
        super();
        this.Id = (Id | 0);
        this.FirstName = FirstName;
        this.LastName = LastName;
        this.Role = Role;
        this.ImageUrl = ImageUrl;
        this.ThumbnailUrl = ThumbnailUrl;
    }
}

export function CompletionGranter_$reflection() {
    return record_type("Shared.SharedModels.CompletionGranter", [], CompletionGranter, () => [["Id", int32_type], ["FirstName", string_type], ["LastName", string_type], ["Role", Role_$reflection()], ["ImageUrl", option_type(string_type)], ["ThumbnailUrl", option_type(string_type)]]);
}

export class HistoricCompletion extends Record {
    constructor(Id, Task, Completed, GrantedBy) {
        super();
        this.Id = (Id | 0);
        this.Task = Task;
        this.Completed = Completed;
        this.GrantedBy = GrantedBy;
    }
}

export function HistoricCompletion_$reflection() {
    return record_type("Shared.SharedModels.HistoricCompletion", [], HistoricCompletion, () => [["Id", int32_type], ["Task", Task_$reflection()], ["Completed", class_type("System.DateTime")], ["GrantedBy", option_type(CompletionGranter_$reflection())]]);
}

export class HistoricEventEntry extends Record {
    constructor(Event$, CompletedTasks, MissingTasks) {
        super();
        this.Event = Event$;
        this.CompletedTasks = CompletedTasks;
        this.MissingTasks = MissingTasks;
    }
}

export function HistoricEventEntry_$reflection() {
    return record_type("Shared.SharedModels.HistoricEventEntry", [], HistoricEventEntry, () => [["Event", Event$_$reflection()], ["CompletedTasks", array_type(HistoricCompletion_$reflection())], ["MissingTasks", array_type(Task_$reflection())]]);
}

export class HistoryEntry extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AttendedEvent", "IsolatedCompletion"];
    }
}

export function HistoryEntry_$reflection() {
    return union_type("Shared.SharedModels.HistoryEntry", [], HistoryEntry, () => [[["Item", HistoricEventEntry_$reflection()]], [["Item", HistoricCompletion_$reflection()]]]);
}

export class MyHistory extends Record {
    constructor(Entries) {
        super();
        this.Entries = Entries;
    }
}

export function MyHistory_$reflection() {
    return record_type("Shared.SharedModels.MyHistory", [], MyHistory, () => [["Entries", array_type(HistoryEntry_$reflection())]]);
}

export class Session extends Record {
    constructor(User, AppVersion, EventNames, UserNames, TrackNames, CourseNames) {
        super();
        this.User = User;
        this.AppVersion = AppVersion;
        this.EventNames = EventNames;
        this.UserNames = UserNames;
        this.TrackNames = TrackNames;
        this.CourseNames = CourseNames;
    }
}

export function Session_$reflection() {
    return record_type("Shared.SharedModels.Session", [], Session, () => [["User", User_$reflection()], ["AppVersion", option_type(string_type)], ["EventNames", array_type(tuple_type(int32_type, string_type))], ["UserNames", array_type(tuple_type(int32_type, string_type))], ["TrackNames", array_type(tuple_type(int32_type, string_type))], ["CourseNames", array_type(tuple_type(int32_type, string_type))]]);
}

export class AuditLogChange extends Record {
    constructor(Field, OldValue, NewValue, OldDisplay, NewDisplay) {
        super();
        this.Field = Field;
        this.OldValue = OldValue;
        this.NewValue = NewValue;
        this.OldDisplay = OldDisplay;
        this.NewDisplay = NewDisplay;
    }
}

export function AuditLogChange_$reflection() {
    return record_type("Shared.SharedModels.AuditLogChange", [], AuditLogChange, () => [["Field", string_type], ["OldValue", option_type(string_type)], ["NewValue", option_type(string_type)], ["OldDisplay", option_type(string_type)], ["NewDisplay", option_type(string_type)]]);
}

export class AuditLog extends Record {
    constructor(DateTime, Action, User, Changes, TableName) {
        super();
        this.DateTime = DateTime;
        this.Action = (Action | 0);
        this.User = User;
        this.Changes = Changes;
        this.TableName = TableName;
    }
}

export function AuditLog_$reflection() {
    return record_type("Shared.SharedModels.AuditLog", [], AuditLog, () => [["DateTime", class_type("System.DateTime")], ["Action", int32_type], ["User", option_type(string_type)], ["Changes", array_type(AuditLogChange_$reflection())], ["TableName", string_type]]);
}

export class NotificationError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TemplateNotFound", "EmptyRecipients", "MissingObjectId", "SubjectNotFound", "ObjectNotFound", "InvalidNotification"];
    }
}

export function NotificationError_$reflection() {
    return union_type("Shared.SharedModels.NotificationError", [], NotificationError, () => [[], [], [], [], [], []]);
}

export class NotificationCase extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["AdminNewUserRegistered", "UserApprovedByAdmin", "EventSeatSecured", "EventWaitingList", "AdminEventFinalized", "LevelDemoted", "RuleAction"];
    }
}

export function NotificationCase_$reflection() {
    return union_type("Shared.SharedModels.NotificationCase", [], NotificationCase, () => [[], [], [], [], [], [], []]);
}

export function NotificationCase__ToTitle(this$) {
    switch (this$.tag) {
        case 1:
            return "Din bruker har blitt godkjent";
        case 2:
            return "Bekreftet plass på kurs";
        case 3:
            return "Du er satt på venteliste for et kurs";
        case 4:
            return "Kurs ferdigstilt";
        case 5:
            return "Nivå nedgradert";
        case 6:
            return "Varsel";
        default:
            return "Ny bruker registrert";
    }
}

export function NotificationCase__ToInt(this$) {
    switch (this$.tag) {
        case 1:
            return 1;
        case 2:
            return 2;
        case 3:
            return 3;
        case 4:
            return 5;
        case 5:
            return 6;
        case 6:
            return 100;
        default:
            return 0;
    }
}

export function NotificationCase_FromInt_Z524259A4(n) {
    switch (n) {
        case 0:
            return new NotificationCase(0, []);
        case 1:
            return new NotificationCase(1, []);
        case 2:
            return new NotificationCase(2, []);
        case 3:
            return new NotificationCase(3, []);
        case 5:
            return new NotificationCase(4, []);
        case 6:
            return new NotificationCase(5, []);
        case 100:
            return new NotificationCase(6, []);
        default:
            throw new Error(`Could not decode Notification DU from int: ${n}`);
    }
}

export function NotificationCase__ToEmailTemplateFileName(this$) {
    return `${toString(this$)}.html`;
}

export function NotificationCase__ShouldSendEmail(this$) {
    switch (this$.tag) {
        case 5:
            return false;
        case 1:
        case 2:
        case 3:
        case 4:
        case 6:
            return true;
        default:
            return false;
    }
}

export class Notification extends Record {
    constructor(Id, NotificationType, Title, Message, Inserted, ObjectId, Opened) {
        super();
        this.Id = (Id | 0);
        this.NotificationType = NotificationType;
        this.Title = Title;
        this.Message = Message;
        this.Inserted = Inserted;
        this.ObjectId = ObjectId;
        this.Opened = Opened;
    }
}

export function Notification_$reflection() {
    return record_type("Shared.SharedModels.Notification", [], Notification, () => [["Id", int32_type], ["NotificationType", NotificationCase_$reflection()], ["Title", string_type], ["Message", string_type], ["Inserted", class_type("System.DateTime")], ["ObjectId", option_type(int32_type)], ["Opened", bool_type]]);
}

export class CalendarInvite extends Record {
    constructor(EventId, CourseName, StartTimeUtc, EndTimeUtc, Location, Description, CourseUrl) {
        super();
        this.EventId = (EventId | 0);
        this.CourseName = CourseName;
        this.StartTimeUtc = StartTimeUtc;
        this.EndTimeUtc = EndTimeUtc;
        this.Location = Location;
        this.Description = Description;
        this.CourseUrl = CourseUrl;
    }
}

export function CalendarInvite_$reflection() {
    return record_type("Shared.SharedModels.CalendarInvite", [], CalendarInvite, () => [["EventId", int32_type], ["CourseName", string_type], ["StartTimeUtc", class_type("System.DateTime")], ["EndTimeUtc", class_type("System.DateTime")], ["Location", string_type], ["Description", string_type], ["CourseUrl", string_type]]);
}

export class AdminUserRoleCount extends Record {
    constructor(Role, Count) {
        super();
        this.Role = Role;
        this.Count = (Count | 0);
    }
}

export function AdminUserRoleCount_$reflection() {
    return record_type("Shared.SharedModels.AdminUserRoleCount", [], AdminUserRoleCount, () => [["Role", Role_$reflection()], ["Count", int32_type]]);
}

export class AdminUsersStats extends Record {
    constructor(Enabled, Deactivated, Pending, Roles, New7, New30) {
        super();
        this.Enabled = (Enabled | 0);
        this.Deactivated = (Deactivated | 0);
        this.Pending = (Pending | 0);
        this.Roles = Roles;
        this.New7 = (New7 | 0);
        this.New30 = (New30 | 0);
    }
}

export function AdminUsersStats_$reflection() {
    return record_type("Shared.SharedModels.AdminUsersStats", [], AdminUsersStats, () => [["Enabled", int32_type], ["Deactivated", int32_type], ["Pending", int32_type], ["Roles", array_type(AdminUserRoleCount_$reflection())], ["New7", int32_type], ["New30", int32_type]]);
}

export class AdminTopTrack extends Record {
    constructor(Name, Enrollments) {
        super();
        this.Name = Name;
        this.Enrollments = (Enrollments | 0);
    }
}

export function AdminTopTrack_$reflection() {
    return record_type("Shared.SharedModels.AdminTopTrack", [], AdminTopTrack, () => [["Name", string_type], ["Enrollments", int32_type]]);
}

export class AdminLearningStats extends Record {
    constructor(TracksEnabled, Enrollments, Inactive, Tasks7, Tasks30, TopTracks) {
        super();
        this.TracksEnabled = (TracksEnabled | 0);
        this.Enrollments = (Enrollments | 0);
        this.Inactive = (Inactive | 0);
        this.Tasks7 = (Tasks7 | 0);
        this.Tasks30 = (Tasks30 | 0);
        this.TopTracks = TopTracks;
    }
}

export function AdminLearningStats_$reflection() {
    return record_type("Shared.SharedModels.AdminLearningStats", [], AdminLearningStats, () => [["TracksEnabled", int32_type], ["Enrollments", int32_type], ["Inactive", int32_type], ["Tasks7", int32_type], ["Tasks30", int32_type], ["TopTracks", array_type(AdminTopTrack_$reflection())]]);
}

export class AdminEventsStats extends Record {
    constructor(Upcoming, Past30) {
        super();
        this.Upcoming = (Upcoming | 0);
        this.Past30 = (Past30 | 0);
    }
}

export function AdminEventsStats_$reflection() {
    return record_type("Shared.SharedModels.AdminEventsStats", [], AdminEventsStats, () => [["Upcoming", int32_type], ["Past30", int32_type]]);
}

export class AdminPanelStats extends Record {
    constructor(Users, Learning, Events) {
        super();
        this.Users = Users;
        this.Learning = Learning;
        this.Events = Events;
    }
}

export function AdminPanelStats_$reflection() {
    return record_type("Shared.SharedModels.AdminPanelStats", [], AdminPanelStats, () => [["Users", AdminUsersStats_$reflection()], ["Learning", AdminLearningStats_$reflection()], ["Events", AdminEventsStats_$reflection()]]);
}

//# sourceMappingURL=SharedModels.jsx.map
